(function () {
  var popup = document.getElementById('size-guide-popup');
  if (!popup) return;

  document.body.appendChild(popup);

  function openPopup() {
    popup.removeAttribute('hidden');
    popup.classList.remove('m:hidden');
    document.documentElement.classList.add('prevent-scroll');
  }

  function closePopup() {
    popup.setAttribute('hidden', '');
    popup.classList.add('m:hidden');
    document.documentElement.classList.remove('prevent-scroll');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-sizeguide]')) {
      e.preventDefault();
      openPopup();
    }
    if (e.target.closest('[data-close-sizeguide]')) {
      e.preventDefault();
      closePopup();
    }
  });

  popup.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });
})();
